import React, { useContext } from 'react'
import { NavLink } from 'reactstrap'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { konusmaciArr } from "./KonusmacilarData";


function Konusmacilar()
{

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    lazyLoad: 'ondemand'
  };

  return (
    <>
      <div className='container my-4 mb-5 slick-slider-big'>
        <div className='homeTitle'>
          KONUŞMACILAR
          <span className='all'>
            <NavLink tag={Link} to="konusmacilar">Tümünü gör<i class="bi bi-chevron-right"></i></NavLink>
          </span>
        </div>
        <Slider {...settings}>
          {
            konusmaciArr.map((konucmaci) => (
              <div className='box'>
                <img src={konucmaci?.src} class="d-block w-100" alt="Konuşmacı" />
              </div>
            ))
          }
        </Slider>
      </div>
    </>
  );
}

export default Konusmacilar;